import { render } from "./TimeTable.vue?vue&type=template&id=c081fb3a"
import script from "./TimeTable.vue?vue&type=script&lang=js"
export * from "./TimeTable.vue?vue&type=script&lang=js"
script.render = render

export default script